// Sorting

export type PrimarySortCriterion =
  | "suggested"
  | "distance"
  | "soldDate"
  | "pricePerSqft"
  | "beds"
  | "baths"
  | "yearBuilt"
  | "squareFeet"
  | "soldPrice"
  | "daysOnMarket"
  | "updatedAt"

// Then SortCriterion includes both primary and prefixed types
export type CompSortCriterion =
  | PrimarySortCriterion
  | `selectedFirst_${PrimarySortCriterion}`

export type CompSortOrder = "default" | "reverse"

// Combines a sort criterion with its order
export interface CompSortOption {
  criterion: CompSortCriterion
  order: CompSortOrder
  uiDisplay?: boolean // Controls visibility in UI, defaults to true if not specified
}

// Define the mapping of sort options to SortCriterion types
export const sortOptions: Record<string, CompSortOption> = {
  "Our Picks": { criterion: "suggested", order: "default" },
  Distance: { criterion: "distance", order: "default" },
  "Sold Date": { criterion: "soldDate", order: "reverse" },
  "$/Sq Ft": { criterion: "pricePerSqft", order: "reverse" },
  Beds: { criterion: "beds", order: "default" },
  Baths: { criterion: "baths", order: "default" },
  "Year Built": { criterion: "yearBuilt", order: "reverse" },
  "Sq ft": { criterion: "squareFeet", order: "reverse" },
  "Sold Price": { criterion: "soldPrice", order: "reverse" },
  DOM: { criterion: "daysOnMarket", order: "default" },
  "Updated At": { criterion: "updatedAt", order: "default", uiDisplay: false },
}
